import { DataRoomDiligenceRequest } from '../../shared/models';
import { EditQuestionForm } from './EditQuestionForm';
import { EditRequestDocumentForm } from './EditRequestDocumentForm';

interface EditDiligenceRequestFormProps {
	dataRoomGuid: string | undefined;
	request: DataRoomDiligenceRequest | null;
	close: () => void;
}

export const EditDiligenceRequestForm: React.FC<EditDiligenceRequestFormProps> = ({ dataRoomGuid, request, close }) => {
	if (request == null) return <></>;

	return request.diligenceType == 'Question' ? (
		<EditQuestionForm dataRoomGuid={dataRoomGuid} request={request} close={close} />
	) : (
		<EditRequestDocumentForm dataRoomGuid={dataRoomGuid} request={request} close={close} />
	);
};
